import React, { useEffect } from 'react'
import AOS from "aos";
import "aos/dist/aos.css";

const OurSolution = () => {
  useEffect(() => {
    AOS.init({
      once: false,
      duration: 800,
      easing: 'ease-out'
    });
  }, []);

  return (
   <section className="lg:py-28 lg:px-12 px-5 py-12 bg-bgDefault text-white">
      <div className="container mx-auto max-w-screen-xl">
        {/* Header */}


        {/* Content Container */}
        <div className="lg:px-[168px]">
          {/* Description */}
          <h2
            className="text-3xl lg:text-4xl font-bold tracking-tight mb-6 lg:mb-8"
            data-aos="fade-down"
          >
            What We Did & How We Did It
          </h2>

          {/* <h3 className="text-2xl lg:text-3xl font-semibold text-[#00E599] mb-4">What We Did & How We Did It</h3> */}

          <p
            className="text-[#9E9E9E] text-base lg:text-lg leading-relaxed mb-6"
            data-aos="fade-up"
            data-aos-delay="100"
          >
            We architected a high-throughput real-time advertising analytics platform using Spring Boot and Spring REST
            for robust backend APIs, Angular (v4/6) for dynamic dashboards, and Amazon SQS for reliable asynchronous
            message processing. The solution employs MySQL for persistent campaign data storage, Redis for ultra-fast
            caching and real-time metric aggregation, and JWT-based Spring Security for authentication. Deployed on AWS
            Cloud with Docker containerization and Jenkins CI/CD pipelines, the platform ensures scalability, reliability,
            and real-time responsiveness.
          </p>

          <h4
            className="text-xl font-semibold text-white mb-3"
            data-aos="fade-right"
            data-aos-delay="200"
          >
            Core Features Delivered:
          </h4>
          <ul className="text-[#9E9E9E] text-base lg:text-lg leading-relaxed mb-6 list-disc pl-5 space-y-2">
            <li data-aos="zoom-in" data-aos-delay="250"><strong>Real-Time Event Processing:</strong> Amazon SQS message queues handle millions of campaign events (impressions, clicks, conversions) with guaranteed delivery and fault tolerance</li>
            <li data-aos="zoom-in" data-aos-delay="300"><strong>Live Analytics Dashboard:</strong> Angular-based interactive dashboards displaying real-time metrics with automatic refresh, custom visualizations, and drill-down capabilities</li>
            <li data-aos="zoom-in" data-aos-delay="350"><strong>Redis Caching Layer:</strong> Sub-second metric retrieval through intelligent caching of frequently accessed campaign data and pre-aggregated statistics</li>
            <li data-aos="zoom-in" data-aos-delay="400"><strong>Automated Reporting Engine:</strong> Customizable report templates generating PDF/Excel exports tailored to client-specific KPIs and timeframes</li>
            <li data-aos="zoom-in" data-aos-delay="450"><strong>Multi-Channel Integration:</strong> RESTful APIs connecting to Google Ads, Facebook Ads, LinkedIn, and other advertising platforms for unified tracking</li>
            <li data-aos="zoom-in" data-aos-delay="500"><strong>Performance Metrics:</strong> Comprehensive analytics including impressions, clicks, CTR, conversions, CPA, ROI, and custom conversion tracking</li>
            <li data-aos="zoom-in" data-aos-delay="550"><strong>Alert System:</strong> Real-time notifications for campaign performance anomalies, budget thresholds, and optimization opportunities</li>
            <li data-aos="zoom-in" data-aos-delay="600"><strong>Historical Analysis:</strong> MySQL data warehouse enabling trend analysis, A/B testing insights, and predictive campaign modeling</li>
          </ul>

          <h2
            className="text-3xl lg:text-4xl font-bold tracking-tight mb-6 lg:mb-8"
            data-aos="fade-down"
            data-aos-delay="650"
          >
            Results Achieved
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
            <div className="bg-[#242424] p-6 rounded-lg border border-[#00E599]/20" data-aos="flip-left" data-aos-delay="700">
              <h5 className="text-3xl font-bold text-[#00E599] mb-2">Millions</h5>
              <p className="text-[#9E9E9E]">Campaign interactions processed daily without degradation</p>
            </div>
            <div className="bg-[#242424] p-6 rounded-lg border border-[#00E599]/20" data-aos="flip-left" data-aos-delay="750">
              <h5 className="text-3xl font-bold text-[#00E599] mb-2">&lt;1s</h5>
              <p className="text-[#9E9E9E]">Dashboard update latency for real-time insights</p>
            </div>
            <div className="bg-[#242424] p-6 rounded-lg border border-[#00E599]/20" data-aos="flip-left" data-aos-delay="800">
              <h5 className="text-3xl font-bold text-[#00E599] mb-2">50%</h5>
              <p className="text-[#9E9E9E]">Reduction in manual analysis time through automation</p>
            </div>
            <div className="bg-[#242424] p-6 rounded-lg border border-[#00E599]/20" data-aos="flip-left" data-aos-delay="850">
              <h5 className="text-3xl font-bold text-[#00E599] mb-2">99.9%</h5>
              <p className="text-[#9E9E9E]">Platform uptime during peak advertising seasons</p>
            </div>
            <div className="bg-[#242424] p-6 rounded-lg border border-[#00E599]/20" data-aos="flip-left" data-aos-delay="900">
              <h5 className="text-3xl font-bold text-[#00E599] mb-2">35%</h5>
              <p className="text-[#9E9E9E]">Average improvement in campaign ROI through real-time optimization</p>
            </div>
            <div className="bg-[#242424] p-6 rounded-lg border border-[#00E599]/20" data-aos="flip-left" data-aos-delay="950">
              <h5 className="text-3xl font-bold text-[#00E599] mb-2">100%</h5>
              <p className="text-[#9E9E9E]">Compliance with data protection and audit standards</p>
            </div>
          </div>

          <p
            className="text-[#9E9E9E] text-base lg:text-lg leading-relaxed"
            data-aos="fade-up"
            data-aos-delay="1000"
          >
            The real-time advertising platform transformed how advertisers monitor and optimize campaigns, delivering
            instant insights that enable data-driven decision-making. Automated reporting freed analysts to focus on
            strategic planning, while multi-channel integration provided unified campaign visibility. The solution's
            scalability and reliability during peak periods established the client as an industry leader in advertising
            analytics innovation.
          </p>
        </div>
      </div>
    </section>
  )
}

export default OurSolution
